import Icon from '@/components/ui/AppIcon';

interface ServiceCardProps {
  icon: string;
  title: string;
  description: string;
  features: string[];
  compliance: string;
}

export default function ServiceCard({
  icon,
  title,
  description,
  features,
  compliance,
}: ServiceCardProps) {
  return (
    <div className="bg-card border border-border rounded-sm p-8 hover:shadow-institutional transition-shadow duration-smooth">
      <div className="flex items-start space-x-4 mb-6">
        <div className="flex-shrink-0 w-12 h-12 bg-primary/5 rounded-sm flex items-center justify-center">
          <Icon name={icon as any} size={24} variant="outline" className="text-primary" />
        </div>
        <div className="flex-1">
          <h3 className="font-headline font-semibold text-xl text-primary mb-2">
            {title}
          </h3>
          <p className="font-body text-sm text-text-secondary leading-relaxed">
            {description}
          </p>
        </div>
      </div>

      <div className="space-y-3 mb-6">
        {features.map((feature, index) => (
          <div key={index} className="flex items-start space-x-3">
            <Icon
              name="CheckCircleIcon"
              size={20}
              variant="solid"
              className="text-success flex-shrink-0 mt-0.5"
            />
            <span className="font-body text-sm text-text-primary">{feature}</span>
          </div>
        ))}
      </div>

      <div className="pt-4 border-t border-border">
        <div className="flex items-center space-x-2">
          <Icon name="ShieldCheckIcon" size={18} variant="solid" className="text-accent" />
          <span className="font-accent text-xs text-text-secondary">{compliance}</span>
        </div>
      </div>
    </div>
  );
}